import React from 'react';
import Image from 'next/image';
import brandLogo from '../../assets/auth/closerstill-logo.png';

export function AuthenticationHeader() {
  return (
    <header aria-label="Brand" className="grid place-items-center">
      <Image src={brandLogo} alt="CloserStill logo" priority className="block w-[23.0675rem] max-w-full h-auto 2xl:w-[29.375rem]" />
    </header>
  );
}
